<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
// 导入主布局样式
@import './assets/styles/app-layout.scss';
@import "./assets/styles/common.scss";
</style>
